import { cn } from "@/lib/utils";
import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Header } from "@/components/layout/components/Header";
import { Sidebar } from "@/components/layout/components/Sidebar";
import { useAuthenticatedUser } from "@/hooks/useAuthenticatedUser";
import { SubscriptionLockOverlay } from "@/components/layout/components/SubscriptionLockOverlay";
import { ActiveHotelLockOverlay } from "@/components/layout/components/ActiveHotelLockOverlay";
import { ProfileUnavailableState } from "@/components/layout/components/ProfileUnavailableState";
import { resolveLayoutContentState } from "@/components/layout/utils/layoutContentState";
import { PageState } from "@/components/common/PageState";
import { FrontdeskBlockGuard } from "@/components/auth/FrontdeskBlockGuard";

export const Layout: React.FC = () => {
  const { t } = useTranslation();
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const { userProfile, isLoading } = useAuthenticatedUser();
  const contentState = resolveLayoutContentState({ isLoading, userProfile });

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  return (
    <div className="flex h-screen overflow-hidden">
      <Sidebar open={sidebarOpen} />

      <div className={cn("flex min-h-0 flex-1 flex-col overflow-hidden")}>
        <Header
          onOpenSidebar={toggleSidebar}
          sidebarOpen={sidebarOpen}
          onToggle={toggleSidebar}
        />
        <main className="font-geist min-h-0 flex-1 overflow-x-clip overflow-y-auto">
          {contentState === "loading-profile" && (
            <PageState text={t("common.loading")} />
          )}
          {contentState === "profile-unavailable" && (
            <ProfileUnavailableState />
          )}
          {(contentState === "ready" || contentState === "refreshing") && (
            <FrontdeskBlockGuard>
              <Outlet />
            </FrontdeskBlockGuard>
          )}
        </main>
      </div>
      <SubscriptionLockOverlay
        isLoading={isLoading}
        userProfile={userProfile}
      />
      <ActiveHotelLockOverlay isLoading={isLoading} userProfile={userProfile} />
    </div>
  );
};
